import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-delete',
  imports: [CommonModule],
  templateUrl: './delete.component.html',
  styleUrl: './delete.component.scss'
})
export class DeleteComponent {
  @Input() recordId!: string // Add businessId input
  @Output() confirm = new EventEmitter<{ id: string }>() // Emit the business ID and status
  @Output() cancel = new EventEmitter<void>()

  constructor(private modalService: NgbModal) {}

  onConfirm() {
    const result = { id: this.recordId }
    this.modalService.dismissAll(result) // This will pass the result back to the parent
  }

  onCancel() {
    this.cancel.emit()
    this.modalService.dismissAll() // Pass the result back
  }
}
